import { render, staticRenderFns } from "./MaterialTrabajo.vue?vue&type=template&id=68079e51&"
import script from "./MaterialTrabajo.vue?vue&type=script&lang=js&"
export * from "./MaterialTrabajo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports